import React from "react";
import { Bookings } from "~/components/client";
import PageMeta from "~/components/common/meta";

export const JobsView: React.FC = () => {
  return (
    <>
      <PageMeta title={`Your Bookings | Art Handler`} />
      <Bookings />
    </>
  );
};

export default JobsView;
